import { useApiService, useDisplayLanguages, useRouter, useTl } from "..";
import {
  AbsenceApi,
  EmployeeApi,
  MailTemplateApi,
  NewComerApi,
  OccupationApi,
  ReferentialApi,
  RoomApi,
  SessionApi,
  SiteApi,
  TrainingApi,
  TrainingPlanificationApi,
  TrainingTypeApi,
  TranslationApi,
  UserApi,
  LanguageApi,
  DataTranslationApi,
  SmsTemplateApi,
  ActionRoleApi,
  AttendanceApi,
  RegistrationApi,
  MeetingApi,
  ContactApi,
  PartnerTypeApi,
  PartnerApi,
  MeetingDashboardApi,
  DutyApi,
  MeetingTypeApi,
  FunctionApi,
  AssignmentApi,
  HourlyTypeApi,
  ReportApi,
  AzureEventApi,
  ThematicTypeApi,
  NewComerFileApi,
  TranslationCodeApi,
} from "../../api";
import {
  useDialog,
  useEventsContext,
  useGlobalData,
  useNavigationContext,
} from "../../contexts";
import { useManageValidationErrors } from "../useManageValidationErrors";
import { useAuth } from "../../contexts/AuthContext";
import { useBreadcrumbData } from "../useBreadcrumbData.tsx";

export function useCommonHooks() {
  return {
    ...useTl(),
    router: useRouter(),
    ...useBreadcrumbData(),
    ...useAuth(),
    ...useGlobalData(),
    ...useEventsContext(),
    ...useNavigationContext(),
    ...useDialog(),
    ...useManageValidationErrors(),
    ...useDisplayLanguages(),
    apis: {
      translations: useApiService(TranslationApi),
      translationCodes: useApiService(TranslationCodeApi),
      user: useApiService(UserApi),
      referentials: useApiService(ReferentialApi),
      site: useApiService(SiteApi),
      room: useApiService(RoomApi),
      trainingType: useApiService(TrainingTypeApi),
      hourlyType: useApiService(HourlyTypeApi),
      training: useApiService(TrainingApi),
      employee: useApiService(EmployeeApi),
      absence: useApiService(AbsenceApi),
      trainingPlanification: useApiService(TrainingPlanificationApi),
      sessions: useApiService(SessionApi),
      occupations: useApiService(OccupationApi),
      mailTemplates: useApiService(MailTemplateApi),
      language: useApiService(LanguageApi),
      newComers: useApiService(NewComerApi),
      dataTranslations: useApiService(DataTranslationApi),
      smsTemplates: useApiService(SmsTemplateApi),
      actionRoles: useApiService(ActionRoleApi),
      attendance: useApiService(AttendanceApi),
      registrations: useApiService(RegistrationApi),
      meetings: useApiService(MeetingApi),
      contacts: useApiService(ContactApi),
      partnerType: useApiService(PartnerTypeApi),
      meetingType: useApiService(MeetingTypeApi),
      assignment: useApiService(AssignmentApi),
      partner: useApiService(PartnerApi),
      meetingDashboard: useApiService(MeetingDashboardApi),
      duty: useApiService(DutyApi),
      functionApi: useApiService(FunctionApi),
      reportApi: useApiService(ReportApi),
      azureEventApi: useApiService(AzureEventApi),
      thematicType: useApiService(ThematicTypeApi),
      newComerFileApi: useApiService(NewComerFileApi),
    },
  };
}
